import { Project, RootState } from '@greenkub-fronts/shared/interface';

export const getCurrentProject = (
  rootState: RootState
): Project | undefined => {
  let query;

  if (rootState.signature.isSignature) {
    query =
      rootState.api.queries[
        `getProjectByToken({"groupName":"ProjectForPageSignature","token":"${rootState.signature.projectToken}"})`
      ];
  } else {
    if (!rootState.signature.projectId) return undefined;
    let projectId: any;
    if (typeof rootState.signature.projectId === 'string') {
      projectId = parseInt(rootState.signature.projectId);
    } else {
      projectId = rootState.signature.projectId;
    }

    query =
      rootState.api.queries[
        `getProjectById({"groupName":"ProjectForPageSignature","projectId":${projectId}})`
      ];
  }

  if (query && query.status === 'fulfilled') {
    return query.data;
  }

  return undefined;
};
